import styled from 'styled-components';

/* Rendered inside `.ps-redesign`, so the Program Setup design tokens (--ink, --line, ...) apply. */

export const ChCard = styled.section`
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r);
  box-shadow: var(--shadow);
  margin: 0 0 18px;
`;

export const ChHead = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 13px;
  padding: 18px 22px;
  flex-wrap: wrap;
`;

export const ChIc = styled.div`
  width: 38px;
  height: 38px;
  border-radius: 10px;
  flex: none;
  display: grid;
  place-items: center;
  background: var(--ic-rec-bg);
  color: var(--ic-rec-fg);

  svg {
    width: 19px;
    height: 19px;
  }
`;

export const ChTitles = styled.div`
  flex: 1 1 180px;
  min-width: 0;
`;

export const ChTitle = styled.div`
  font-size: 16.5px;
  font-weight: 700;
  letter-spacing: -0.015em;
`;

export const ChSub = styled.div`
  font-size: 12.5px;
  color: var(--ink-3);
  margin-top: 2px;
`;

export const ChAside = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Scope = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 9px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: var(--accent-soft);
  color: var(--accent-ink);
`;

export const Dirty = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: var(--warn);
  background: var(--warn-soft);
  padding: 5px 11px;
  border-radius: 999px;

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
  }
`;

export const ChBody = styled.div`
  padding: 0 22px 22px;
`;

export const ChGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px 18px;

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
`;

export const ChFoot = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid var(--line-2);
`;

export const AdsBox = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 12px 16px;
  border: 1px solid var(--line);
  border-radius: 10px;
  background: var(--raise);
  flex: 1 1 320px;
`;

export const ToggleLabel = styled.div`
  font-size: 12.5px;
  font-weight: 600;
  color: var(--ink-2);
`;

export const ToggleSub = styled.div`
  font-size: 10.5px;
  color: var(--ink-4);
  line-height: 1.2;
  margin-top: 1px;
`;

export const Toggle = styled.button<{ $on?: boolean }>`
  position: relative;
  width: 42px;
  height: 24px;
  border-radius: 999px;
  border: 0;
  flex: none;
  cursor: pointer;
  padding: 0;
  background: ${({ $on }) => ($on ? 'var(--ok)' : '#d7dde8')};
  transition: background 0.18s ease;

  &::after {
    content: '';
    position: absolute;
    top: 3px;
    left: ${({ $on }) => ($on ? '21px' : '3px')};
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.28);
    transition: left 0.18s ease;
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const Hint = styled.div`
  font-size: 12px;
  color: var(--ink-4);
`;

/* ---------- read-only inherited box (program drawer) ---------- */
export const Inherit = styled.div`
  margin-top: 18px;
  padding: 14px 16px;
  border: 1px dashed var(--line);
  border-radius: 10px;
  background: var(--raise);
`;

export const InheritHead = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 10px;

  .t {
    font-size: 11.5px;
    font-weight: 700;
    color: var(--ink-2);
  }
  .w {
    font-size: 11.5px;
    color: var(--ink-4);
  }
`;

export const InheritGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px 26px;
`;

export const InheritCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;

  .k {
    font-size: 9.5px;
    font-weight: 700;
    letter-spacing: 0.1em;
    color: var(--ink-4);
  }
  .v {
    font-size: 13px;
    font-weight: 600;
    color: var(--ink-2);
  }
`;
